export default __webpack_public_path__ + "static/media/butterfly.709ec4ce.png";